import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';
import CheckoutHeader from '@checkout/components/header/CheckoutHeader.jsx';

const {moduleScope, config} = JshModule('checkout/header');

createRoot(moduleScope).render(
    <CheckoutHeader
    rootUrl={config.rootUrl}
    secureConnectionText = {config.cot14_sichere_verbindung}
    headerInfoMessage={config.headerInfoMessage}
    />
);